var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.354,
    height: 13.354,
    viewBox: "0 0 13.354 13.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pencil-alt",
    d: "M13.009,3.779l-1.2,1.2a.313.313,0,0,1-.443,0l-2.9-2.9a.313.313,0,0,1,0-.443l1.2-1.2a1.255,1.255,0,0,1,1.771,0l1.568,1.568A1.25,1.25,0,0,1,13.009,3.779Zm-5.574-1.1L.586,9.525.034,12.694a.627.627,0,0,0,.725.725l3.169-.556,6.849-6.849a.313.313,0,0,0,0-.443l-2.9-2.9a.316.316,0,0,0-.446,0ZM3.26,8.938a.364.364,0,0,1,0-.516L7.277,4.405a.365.365,0,0,1,.516.516L3.776,8.938a.364.364,0,0,1-.516,0Zm-.942,2.194H3.57v.947l-1.682.295-.811-.811L1.372,9.88h.947Z",
    transform: "translate(-0.024 -0.075)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.30cab8d2a8d317ae18f1a6be6511686e.svg";
export { ForwardRef as ReactComponent };